__turbopack_context__.v({
  "NossoNumeros": "WKqWUa_NossoNumeros",
  "boxNossoNumeros": "WKqWUa_boxNossoNumeros",
  "chamada": "WKqWUa_chamada",
  "contentNumeros": "WKqWUa_contentNumeros",
  "dFlex": "WKqWUa_dFlex",
  "icon": "WKqWUa_icon",
  "itemNumeros": "WKqWUa_itemNumeros",
  "number": "WKqWUa_number",
});
